import React from 'react';
function PhoneNumberValidation(props) {
    const cleanedNum = ('' + props).replace(/\D/g, '');
    const matchNum = cleanedNum.match(/^(\d{3})(\d{3})(\d+)$/);
    if (matchNum) {
        return `(${matchNum[1]}) ${matchNum[2]}-${matchNum[3]}`;
    }
    return props;
}
export default PhoneNumberValidation